export type AstraLabEvent = 'TRACKING' | 'B2B_LANDING' | 'EMPLOYER_REGISTRATION';

const ASTRA_LAB_PIXELS: Record<AstraLabEvent, string[]> = {
    TRACKING: [
        'https://px.adhigh.net/p/tracking.gif?syncs=default&site_id=8480',
        'https://px.adhigh.net/p/tracking.gif?syncs=bsw&syncs_only=true',
        'https://mc.yandex.ru/pixel/2813014650794035776?rnd=%aw_random%',
        'https://rtb-eu.b.otm-r.com/spevent?sadd=10000141',
    ],
    B2B_LANDING: [
        'https://px.adhigh.net/p/tracking.gif?syncs=default&site_id=8744',
        'https://px.adhigh.net/p/tracking.gif?syncs=bsw&syncs_only=true',
        'https://mc.yandex.ru/pixel/87190232358378587?rnd=%aw_random%',
        'https://ssp.afp.ai/api/smart_pixel/6314107635',
        'https://rtb-eu.b.otm-r.com/spevent?sadd=10000418',
    ],
    EMPLOYER_REGISTRATION: [
        'https://px.adhigh.net/p/tracking.gif?syncs=default&site_id=8745',
        'https://px.adhigh.net/p/tracking.gif?syncs=bsw&syncs_only=true',
        'https://mc.yandex.ru/pixel/6086011030574177720?rnd=%aw_random%',
        'https://ssp.afp.ai/api/smart_pixel/6314125095',
        'https://rtb-eu.b.otm-r.com/spevent?sadd=10000419',
    ],
};

export const sendAstraLabEvent = (event: AstraLabEvent): void => {
    const pixels = ASTRA_LAB_PIXELS[event];

    if (!pixels?.length) {
        return;
    }

    pixels.forEach((item) => {
        const pixel = new Image();
        pixel.src = item;
        pixel.style.display = 'none';
        document.body.appendChild(pixel);
    });
};
